const customersKeys = {
  index: "customers",
  customerByUserId: "customers-by-user-id",
  customerServiceContractsByUserId: "customer-service-contracts-by-user-id",
  customerUpdate: "customers-update",
  customerKross: "customer-kross",
  customerHostify: "customer-hostify",
  customerPhone: "customer-phone",
  subUsers: "sub-users",
  subUserRooms: "sub-user-rooms",
  inviteSubUser: "invite-sub-user",
  removeSubUser: "remove-sub-user",
  setSubUserRooms: "set-sub-user-rooms",
  assignAllRooms: "assign-all-rooms",
  resendInvite: "resend-invite",
};

export const customerByUserIdKey = (id: string) => {
  return [customersKeys.index, customersKeys.customerByUserId, id];
};

export const customerUpdateKey = () => {
  return [customersKeys.index, customersKeys.customerUpdate];
};

export const customerServiceContractsByUserIdKey = (id: string) => {
  return [customersKeys.index, customersKeys.customerServiceContractsByUserId, id];
};

export const customerKrossKey = (id: string) => {
  return [customersKeys.index, customersKeys.customerKross, id];
};

export const customerHostifyKey = (id: string) => {
  return [customersKeys.index, customersKeys.customerHostify, id];
};

export const customerPhoneKey = (userId: string) => {
  return [customersKeys.index, customersKeys.customerPhone, userId];
};

export const subUsersKey = (customerId: string) => {
  return [customersKeys.index, customersKeys.subUsers, customerId];
};

export const subUserRoomsKey = (customerId: string, userId: string) => {
  return [customersKeys.index, customersKeys.subUserRooms, customerId, userId];
};

export const inviteSubUserKey = () => {
  return [customersKeys.index, customersKeys.inviteSubUser];
};

export const removeSubUserKey = () => {
  return [customersKeys.index, customersKeys.removeSubUser];
};

export const setSubUserRoomsKey = () => {
  return [customersKeys.index, customersKeys.setSubUserRooms];
};

export const assignAllRoomsKey = () => {
  return [customersKeys.index, customersKeys.assignAllRooms];
};

export const resendInviteKey = () => {
  return [customersKeys.index, customersKeys.resendInvite];
};
